import { IdentificationRequestChatQuery } from './IdentificationRequestChat.query';

interface IIdentificationRequestChat {
  open: boolean;
  onClose: () => void;
}

export const IdentificationRequestChat = (data: IIdentificationRequestChat) => {
  return <IdentificationRequestChatQuery {...data} />;
};
